import { CommentDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';

export namespace DataExportActions {
  export const Types = {
    requestSaveFile: '[DataExport] request download',
    successSaveFile: '[DataExport] success download',
    requestExportCustomersStatistics: '[DataExport] customer stats',
    requestExportMembersStatistics: '[DataExport] members stats',
    requestExportFeedback: '[DataExport] feedback',
    requestExportFeedbackForOrganisations: '[DataExport][Multi] feedback',
    requestExportRecentCommentsForOrganisations: '[DataExport][Multi] recent comments',
    requestExportMembersStatisticsForOrganisations: '[DataExport][Multi] member stats',
    requestExportContentStatisticsForOrganisations: '[DataExport][Multi] content stats',
    requestExportQuestionAnswers: '[DataExport] question answers',
    responseFailDataExport: '[DataExport][Fail]',
  };

  export const requestSaveFile = createAction(
    Types.requestSaveFile,
    props<{ filename: string; mimeType: string; data: any }>(),
  );
  export const successSaveFile = createAction(Types.successSaveFile);

  export const requestExportFeedback = createAction(Types.requestExportFeedback);

  export const requestExportCustomersStatistics = createAction(
    Types.requestExportCustomersStatistics,
  );

  export const requestExportMembersStatistics = createAction(Types.requestExportMembersStatistics);

  export const requestExportFeedbackForOrganisations = createAction(
    Types.requestExportFeedbackForOrganisations,
    props<{ organisationIds: string[] }>(),
  );

  export const requestExportRecentCommentsForOrganisations = createAction(
    Types.requestExportRecentCommentsForOrganisations,
    props<{ organisationIds: string[] }>(),
  );

  export const requestExportQuestionAnswers = createAction(
    Types.requestExportQuestionAnswers,
    props<{ questionId: string }>(),
  );

  export const responseFailDataExport = createAction(
    Types.responseFailDataExport,
    props<{ error?: any }>(),
  );

  export const exportCheckInsForCustomer = createAction(
    '[DataExport] customer checkins',
    props<{ customerId: string }>(),
  );
  export const exportRecentComments = createAction('[DataExport][Request] recent comments');
  export const responseSuccessExportRecentComments = createAction(
    '[DataExport][Response][Success] recent comments',
  );
  export const responseFailExportRecentComments = createAction(
    '[DataExport][Response][Fail] recent comments',
    props<{ error?: any }>(),
  );
}
